import { SvgFactory } from '../../Svg';

const BellIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='33' height='32' viewBox='0 0 33 32' fill='black'>
        <path d='M16.5015 29C17.9682 29 19.1682 27.8 19.1682 26.3333H13.8349C13.8349 27.8 15.0215 29 16.5015 29ZM24.5015 21V14.3333C24.5015 10.24 22.3149 6.81333 18.5015 5.90667V5C18.5015 3.89333 17.6082 3 16.5015 3C15.3949 3 14.5015 3.89333 14.5015 5V5.90667C10.6749 6.81333 8.50153 10.2267 8.50153 14.3333V21L6.78153 22.72C5.94153 23.56 6.5282 25 7.71487 25H25.2749C26.4615 25 27.0615 23.56 26.2215 22.72L24.5015 21Z' />
    </svg>,
);

export default BellIcon;
